import { ACTION_FILTERS } from '@/forms/TimelineFilterForm/types';

const defaultTimelineFilters = {
  action: [
    ACTION_FILTERS.APPOINTMENT,
    ACTION_FILTERS.CHALLENGE,
    ACTION_FILTERS.EPISODE_OF_CARE,
    ACTION_FILTERS.MESSAGE,
    ACTION_FILTERS.PHASE,
    ACTION_FILTERS.PERSON_MERGE,
    ACTION_FILTERS.PROGRAM_QUALIFICATION,
    ACTION_FILTERS.REFERRAL,
    ACTION_FILTERS.SURVEY,
    ACTION_FILTERS.TASK
  ]
};

export default defaultTimelineFilters;
